import { makeActions } from '@redux/crudCreator/actions';
import { apiWrapper } from '@redux/crudCreator/reduxUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getVendorFfmSummaryApi } from 'api/orders';

export const MODEL_NAME = 'vendorFfms';
export const vendorFfmsActions = makeActions(MODEL_NAME, 'id', 'orders');

export const getAllVendorFfms = vendorFfmsActions.getAll;
export const editVendorFfms = vendorFfmsActions.edit;
export const createVendorFfms = vendorFfmsActions.create;
export const getByIdVendorFfms = vendorFfmsActions.getDataById;

export const getVendorFfmSummary = createAsyncThunk(
  'vendorFfms/getVendorFfmSummary',
  async (payload, thunkAPI) => {
    try {
      const response = await apiWrapper(null, getVendorFfmSummaryApi);

      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue({ error: true, data: response });
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error, error: true });
    }
  },
);
